import React, { ChangeEvent, useRef } from 'react'

interface FileSelector {
  onSelectFiles: (e: ChangeEvent<HTMLInputElement>) => void
}

export function FileSelector({ onSelectFiles }: FileSelector) {
  const fileInputEl = useRef<HTMLInputElement>(null)

  const openFileInput = () => fileInputEl.current?.click()

  return (
    <>
      <input
        type='file'
        multiple
        ref={fileInputEl}
        className='hidden'
        accept='image/*,.pdf,.doc,.docx,.xml,.json'
        onChange={(e) => onSelectFiles(e)}
      />
      <button
        onClick={openFileInput}
        className='bg-blue-500 text-white py-2 px-5 rounded'
      >
        Browse
      </button>
    </>
  )
}
